// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"z--z"};